<template>
<!-- 모의투자 : 메인 > 안내 -->
<!-- 모의투자 : 메인 > 안내 -->
<div class="sts-main-banner">
    <div class="banner-inner">
        <div class="banner-inner-box">

            <div class="banner-inner-top">
                <p class="title">주식, 선물, 코인 모의투자 거래를<br><strong class="text-danger">단 하나의 플랫폼</strong>에서</p>
                <div class="banner-top-btn">
                    <a href="#" class="btn btn-danger" @click="onDetailInfo">대회 안내</a>
                </div>
            </div>

            <div class="banner-card-area mt-5">
                <!-- <Carousel :settings="settings"> -->
                    <!-- <Slide
                        v-for="(item, index) in vContestData"
                        :key = index
                    > -->
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                    <div    
                        v-if="vContestData_S"
                            class="banner-inner-card"
                            :class="[
                                `type-${vContestData_S.TYPE}`,
                                vContestData_S._isApply ? 'on'
                                : vContestData_S.STATUS == '3' ? 'none' : ''
                            ]
                            "
                    >
                        <span class="date">
                            {{moment( vContestData_S.STARTDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }} ~ {{moment( vContestData_S.ENDDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }}
                        </span>
                        <div class="title">
                            {{getSpaceTypeName(vContestData_S.TYPE)}}
                        <span>{{vContestData_S.NAME}}</span>    
                        </div>
                        <div v-if="!vContestData_S._isApply">
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn" @click="onRegisterTrade(vContestData_S)">
                                        <span class="bold" v-if="vContestData_S.STATUS == '1'">시작하기</span>
                                        <span class="bold" v-else-if="vContestData_S.STATUS == '3'">준비중</span>
                                        <span class="bold" v-else-if="vContestData_S.STATUS == '9'">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr(vContestData_S.TYPE)}}
                            </div>                        
                        </div>

                        <div v-else>
                            <div class="inner-card-btn">
                                <div class="type-2">
                                    <button type="button" class="btn" @click="onGotoTrade(vContestData_S.TYPE)">거래 하러가기</button>
                                    <button type="button" class="btn" @click="onClickRetry_retry(vContestData_S)">재도전</button>
                                </div>
                            </div>
                            <div class="card-info">
                                <ul>
                                    <li>
                                        <div class="txt">나의 수익률</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(Number(getProfitPreType('S').toFixed(2))) + ' %'}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 평가손익</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(getProfitType('S'))}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 랭킹</div>
                                        <div class="number">{{getMyRankType('S')}}위</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-else
                        class="banner-inner-card"
                        :class="
                        `type-${'S'}`
                        "
                    >
                        <span class="date">
                            {{'0000. 00. 00' }} ~  {{'0000. 00. 00' }}
                        </span>
                        <div class="title">{{getSpaceTypeName('S')}}</div>
                        <!-- <span>{{'..........'}}</span>     -->
                        <div>
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn">
                                        <span class="bold">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr('S')}}
                            </div>                        
                        </div>
                    </div>
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                    <div
                        v-if="vContestData_F"
                            class="banner-inner-card"
                        :class="[
                                `type-${vContestData_F.TYPE}`,
                                vContestData_F._isApply ? 'on'
                                : vContestData_F.STATUS == '3' ? 'none' : ''
                            ]
                            "
                    >
                        <span class="date">
                            {{moment( vContestData_F.STARTDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }} ~ {{moment( vContestData_F.ENDDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }}
                        </span>
                        <div class="title">
                            {{getSpaceTypeName(vContestData_F.TYPE)}}
                        <span>{{vContestData_F.NAME}}</span>    
                        </div>
                        <div v-if="!vContestData_F._isApply">
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn" @click="onRegisterTrade(vContestData_F)">
                                        <span class="bold" v-if="vContestData_F.STATUS == '1'">시작하기</span>
                                        <span class="bold" v-else-if="vContestData_F.STATUS == '3'">준비중</span>
                                        <span class="bold" v-else-if="vContestData_F.STATUS == '9'">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr(vContestData_F.TYPE)}}
                            </div>                        
                        </div>

                        <div v-else>
                            <div class="inner-card-btn">
                                <div class="type-2">
                                    <button type="button" class="btn" @click="onGotoTrade(vContestData_F.TYPE)">거래 하러가기</button>
                                    <button type="button" class="btn" @click="onClickRetry_retry(vContestData_F)">재도전</button>
                                </div>
                            </div>
                            <div class="card-info">
                                <ul>
                                    <li>
                                        <div class="txt">나의 수익률</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(Number(getProfitPreType('F').toFixed(2))) + ' %'}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 평가손익</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(getProfitType('F'))}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 랭킹</div>
                                        <div class="number">{{getMyRankType('F')}}위</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-else
                        class="banner-inner-card"
                        :class="
                        `type-${'F'}`
                        "
                    >
                        <span class="date">
                            {{'0000. 00. 00' }} ~  {{'0000. 00. 00' }}
                        </span>
                        <div class="title">{{getSpaceTypeName('F')}}</div>
                        <!-- <span>{{'..........'}}</span>     -->
                        <div>
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn">
                                        <span class="bold">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr('F')}}
                            </div>                        
                        </div>
                    </div>
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                    <div
                        v-if="vContestData_G"
                            class="banner-inner-card"
                        :class="[
                                `type-${vContestData_G.TYPE}`,
                                vContestData_G._isApply ? 'on'
                                : vContestData_G.STATUS == '3' ? 'none' : ''
                            ]
                            "
                    >
                        <span class="date">
                            {{moment( vContestData_G.STARTDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }} ~ {{moment( vContestData_G.ENDDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }}
                        </span>
                        <div class="title">
                            {{getSpaceTypeName(vContestData_G.TYPE)}}
                        <span>{{vContestData_G.NAME}}</span>    
                        </div>
                        <div v-if="!vContestData_G._isApply">
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn" @click="onRegisterTrade(vContestData_G)">
                                        <span class="bold" v-if="vContestData_G.STATUS == '1'">시작하기</span>
                                        <span class="bold" v-else-if="vContestData_G.STATUS == '3'">준비중</span>
                                        <span class="bold" v-else-if="vContestData_G.STATUS == '9'">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr(vContestData_G.TYPE)}}
                            </div>                        
                        </div>

                        <div v-else>
                            <div class="inner-card-btn">
                                <div class="type-2">
                                    <button type="button" class="btn" @click="onGotoTrade(vContestData_G.TYPE)">거래 하러가기</button>
                                    <button type="button" class="btn" @click="onClickRetry_retry(vContestData_G)">재도전</button>
                                </div>
                            </div>
                            <div class="card-info">
                                <ul>
                                    <li>
                                        <div class="txt">나의 수익률</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(Number(getProfitPreType('G').toFixed(2))) + ' %'}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 평가손익</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(Number(getProfitType('G').toFixed(2)))}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 랭킹</div>
                                        <div class="number">{{getMyRankType('G')}}위</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-else
                        class="banner-inner-card"
                        :class="
                        `type-${'G'}`
                        "
                    >
                        <span class="date">
                            {{'0000. 00. 00'}} ~  {{'0000. 00. 00'}}
                        </span>
                        <div class="title">{{getSpaceTypeName('G')}}</div>
                        <!-- <span>{{'..........'}}</span>     -->
                        <div>
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn">
                                        <span class="bold">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr('G')}}
                            </div>                        
                        </div>
                    </div>
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->
                    <div
                        v-if="vContestData_C"
                            class="banner-inner-card"
                        :class="[
                                `type-${vContestData_C.TYPE}`,
                                vContestData_C._isApply ? 'on'
                                : vContestData_C.STATUS == '3' ? 'none' : ''
                            ]
                            "
                    >
                        <span class="date">
                            {{moment( vContestData_C.STARTDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }} ~ {{moment( vContestData_C.ENDDATE, 'YYYYMMDDHHmmss' ).format('YYYY. MM. DD') }}
                        </span>
                        <div class="title">
                            {{getSpaceTypeName(vContestData_C.TYPE)}}
                        <span>{{vContestData_C.NAME}}</span>    
                        </div>
                        <div v-if="!vContestData_C._isApply">
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn" @click="onRegisterTrade(vContestData_C)">
                                        <span class="bold" v-if="vContestData_C.STATUS == '1'">시작하기</span>
                                        <span class="bold" v-else-if="vContestData_C.STATUS == '3'">준비중</span>
                                        <span class="bold" v-else-if="vContestData_C.STATUS == '9'">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr(vContestData_C.TYPE)}}
                            </div>                        
                        </div>

                        <div v-else>
                            <div class="inner-card-btn">
                                <div class="type-2">
                                    <button type="button" class="btn" @click="onGotoTrade(vContestData_C.TYPE)">거래 하러가기</button>
                                    <button type="button" class="btn" @click="onClickRetry_retry(vContestData_C)">재도전</button>
                                </div>
                            </div>
                            <div class="card-info">
                                <ul>
                                    <li>
                                        <div class="txt">나의 수익률</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(getProfitPreType('C').toFixed(2)) + ' %'}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 평가손익</div>
                                        <div class="number">
                                            {{Constant.UTIL.numberWithCommas(getProfitType('C'))}}
                                        </div>
                                    </li>
                                    <li>
                                        <div class="txt">나의 랭킹</div>
                                        <div class="number">{{getMyRankType('C')}}위</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-else
                        class="banner-inner-card"
                        :class="
                        `type-${'C'}`
                        "
                    >
                        <span class="date">
                            {{'0000. 00. 00' }} ~  {{'0000. 00. 00' }}
                        </span>
                        <div class="title">{{getSpaceTypeName('C')}}</div>
                        <!-- <span>{{'..........'}}</span>     -->
                        <div>
                            <div class="inner-card-btn">
                                <div class="type-1">
                                    <button type="button" class="btn">
                                        <span class="bold">대회종료</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-bottom-txt">
                                {{getSpaceTypeInfoStr('C')}}

                            </div>                        
                        </div>
                    </div>
                   <!-- ///////////////////////////////////////////////////////////////////////////////////// -->

                    <!-- </Slide> -->
                    <!-- <template #addons>
                        <div v-if="vContestData.length > 4">
                            <Navigation />
                        </div>
                    </template> -->
                <!-- </Carousel> -->
            </div>

            <!-- <div v-else class="banner-card-none">
                진행중인 모의투자 대회가 없습니다.
            </div>  -->
        </div>

    </div>
</div>

<RetryModal
    v-if="showModal_retry" 
    @close="closeModal_retry" 
    @cancle="closeModal_retry" 
    @ok="okModal_retry" 
    :currentSpaceName="currentSelectItem.NAME"
    :recount="currentSelectItem._recount"
    :retrycount="currentSelectItem._retrycount"
/>

<ApplyModal
    v-if="showModal" 
    @close="closeModal" 
    @cancle="closeModal" 
    @ok="okModal" 
    :currentItem="currentSelectItem"
/>

</template>

<script>

import {useApicall} from '@/composables/commonFn';
import {ref, getCurrentInstance, onMounted, computed, watch} from 'vue';
import { useRouter }from 'vue-router'
import { useStore } from 'vuex';
import moment from 'moment';
import ApplyModal from '@/components/popups/ApplyModal.vue';
import RetryModal from '@/components/popups/RetryModal.vue';
//import Config from '../../../public/config.js';
import { event } from 'vue-gtag'
//import { Carousel, Slide, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import Constant from '@/constant.js';
export default {
    components: { 
        ApplyModal,
        RetryModal,
        // Carousel,
        // Slide,
        // Navigation, 
    },
    setup(){   
    const showModal_retry = ref(false)
   // const  trace = getCurrentInstance().appContext.config.globalProperties.$log;
    const {apiCall_g, apiCall_gt, apiCall_pt} = useApicall();

    const rSeletBox = ref(null);
    const store = useStore();
    const showModal = ref(false);  
    const router = useRouter();
    const internalInstance = getCurrentInstance(); 
    const emitter = internalInstance.appContext.config.globalProperties.emitter;    
    const isLogin = computed(() => store.state.user.isLogin);
    const memberData = computed(()=> store.state.user.memberData)
    const btn_apply_ok = ref(null)
    const currentResetData = ref([0,0]);
    const isChecked = ref(false);
    const currentSelectItem = ref(null);
    const mainVisualUrl = ref(process.env.VUE_APP_flexMoneyUrl + 'uploads/main/main_visual.png');
    const isOpenStock = ref(true);
    const isOpenFutures = ref(false);
    const isOpenCoin = ref(false);
    const isOpenCoinFutures = ref(false);

    const vContestData_S = ref(null);
    const vContestData_F = ref(null);
    const vContestData_C = ref(null);
    const vContestData_G = ref(null);

    const profitData_S = ref({});
    const profitData_F = ref({});
    const profitData_C = ref({});
    const profitData_G = ref({});

    // const vContestData_S = ref([]);
    // const vContestData_F = ref([]);
    // const vContestData_G = ref([]);
    // const vContestData_C = ref([]);

    // const getVContestData_type = (type) =>{
    //     return  vContestData.value.find(element => ele+ment.TYPE == type)
    // }
    const getVContestData = async(type)=>{
        

        var res = await apiCall_g(`index/getspacelist?type=${type}&applyType=A&limit=1`);
        if(type == 'S'){   
            vContestData_S.value = res.dataList[0];  
            if(isLogin.value &&  vContestData_S.value)
            {
                setCheckApplay(vContestData_S.value);
                profitData_S.value = await getProfitlist(vContestData_S.value.ID)
            }
        }else if(type == 'F'){
            vContestData_F.value = res.dataList[0];   
            if(isLogin.value &&  vContestData_F.value)
            {
                setCheckApplay(vContestData_F.value);
                profitData_F.value = await getProfitlist(vContestData_F.value.ID)
            }
        }else if(type == 'G'){
            vContestData_G.value = res.dataList[0];   
            if(isLogin.value)
            {
                setCheckApplay(vContestData_G.value);
                profitData_G.value = await getProfitlist(vContestData_G.value.ID)
            }
        }else if(type == 'C'){
            vContestData_C.value = res.dataList[0];   
            if(isLogin.value)
            {
                setCheckApplay(vContestData_C.value);
                profitData_C.value = await getProfitlist(vContestData_C.value.ID)
            }               
        }
        


        // vContestData_S.value = getVContestData_type('S');
        // vContestData_F.value = getVContestData_type('F');
        // vContestData_C.value = getVContestData_type('C');
        // vContestData_G.value = getVContestData_type('G');


    }



    const setCheckApplay = async (vContestData)=>{

            //vContestData.forEach(async (element) => {
                var currnetTimeStp = moment(new Date()).format('X');
                //  var applyStratTimeStp = moment( element.APPLYSTARTDATE, 'YYYYMMDDHHmmss' ).format('X');
                //  var applyEndTimeStp = moment( element.APPLYENDDATE, 'YYYYMMDDHHmmss' ).format('X');
                var stratTimeStp = moment( vContestData.STARTDATE, 'YYYYMMDDHHmmss' ).format('X');
                // var eTimeStp = moment( element.ENDDATE, 'YYYYMMDDHHmmss' ).format('X');
                var res = await apiCall_gt(`vspace/getaccountbyspaceid?spaceId=${vContestData.ID}`)            
                if(res)
                {      
                    // 신청기간 참여 오픈전
                    if(currnetTimeStp < stratTimeStp)
                    {
                    // 신청하고 오픈전
                        vContestData._isApply = 1; 
                    }
                    else
                    {
                    //신청하고 거래가능
                        vContestData._isApply = 2; 
                    }
                    vContestData._recount = res.data.RECOUNT;
                    vContestData._retrycount = res.data.RETRYCOUNT;
                    vContestData._accountId = res.data.ID;
                //  trace("vContestData.value:", res.data)              
                    
                    // if( res.data.ISUSED == 'Y')
                    // {
                    //   element._isApply = true; 
                    // }

                  

                }             
           // });
    }




    const getProfitlist = async(spaceId)=>{    
       // var res = await apiCall_gt(`vspace/getprofitlistbyday?type=${type}&spaceId=${id}`);
        var res = await apiCall_gt(`vspace/getmyrank?spaceId=${spaceId}`);
        return res.rankRow;  
        // if( res)
        // {
        //     if(type == 'S'){
        //         profitData_S.value._dataSum = res.dataSum;
        //         profitData_S.value._rankRow = res.rankRow;
        //     }else if(type == 'F'){
        //         profitData_F.value._dataSum = res.dataSum;
        //         profitData_F.value._rankRow = res.rankRow;
        //     }else if(type == 'C'){
        //         profitData_C.value._dataSum = res.dataSum;
        //         profitData_C.value._rankRow = res.rankRow;
        //     }else if(type == 'G'){
        //         profitData_G.value._dataSum = res.dataSum;
        //         profitData_G.value._rankRow = res.rankRow;
        //     }
        // }
    // trace("getProfitlist~~~", ProfitData.value._rankRow, res)
    }

    const getMyRankType =(type)=>{
        if(type == 'S'){
            if(profitData_S.value){
                return  profitData_S.value.RANK;                 
            }else{
                return '--';
            }
        }else if(type == 'F'){
            if(profitData_F.value){
                return  profitData_F.value.RANK;                 
            }else{
                return '--';
            }
        }else if(type == 'C'){
            if(profitData_C.value){
                return  profitData_C.value.RANK;                 
            }else{
                return '--';
            }
        }else if(type == 'G'){
            if(profitData_G.value){
                return  profitData_G.value.RANK;                 
            }else{
                return '--';
            }
        }
    }

    const getProfitPer = ( myRankData )=>{
        var result = 0     
        var totalProfit = Number(myRankData.value.TOTAL_PROFIT); 
        var paymoney = Number(myRankData.value.PAYMONEY);
        result = (totalProfit/paymoney)*100;
        return result;        
    }

    const getProfitType =(type)=>{
        if(type == 'S'){
            if(profitData_S.value){
                return Number(profitData_S.value.TOTAL_PROFIT);                 
            }else{
                return 0;
            }
        }else if(type == 'F'){
            if(profitData_F.value){
                return Number(profitData_F.value.TOTAL_PROFIT);                 
            }else{
                return 0;
            }
        }else if(type == 'C'){
            if(profitData_C.value){
                return Number(profitData_C.value.TOTAL_PROFIT);                 
            }else{
                return 0;
            }
        }else if(type == 'G'){
            if(profitData_G.value){
                return Number(profitData_G.value.TOTAL_PROFIT);                 
            }else{
                return 0;
            }
        }
    }

    const getProfitPreType = (type) =>{       
        if(type == 'S'){
            if(profitData_S.value ){                
                return getProfitPer(profitData_S);
            }else{
                return 0
            }
        }else if(type == 'F'){
            if(profitData_F.value){
                return getProfitPer(profitData_F);
            }else{
                return 0
            }
        }else if(type == 'C'){
            if(profitData_C.value){
                return  getProfitPer(profitData_C);
            }else{
                return 0
            }
        }else if(type == 'G'){
            if(profitData_G.value){
                return getProfitPer(profitData_G);
            }else{
                return 0
            }
        }
    }



    onMounted(()=>{
       //  trace('TmainTop')
        getVContestData('S');
        getVContestData('F');
        getVContestData('G');
        getVContestData('C');

        // setTimeout(()=>{
        //     setRetrybtn()
        // }, 1000)
    })

    // const setApplyButton = () =>{
    //   // trace("rSeletBox:", rSeletBox.value.value.split('^')[3])
    //     var str = rSeletBox.value.value.split('^')[2];
    //     if(str == 1  || str == 2){
    //         btn_apply_ok.value.text = '신청 완료'            
    //     }
    //     else
    //     {
    //         btn_apply_ok.value.text = '모의투자 신청하기'
    //     }
    // }
    // setTimeout(()=>{
    //         setApplyButton()
    // },1000)

    // const onSeletChange = () =>{     
        
    //     currentSelectItem.value = vContestData.value[rSeletBox.value.value.split("^")[5]];
    //    // trace("currentSelectItem.value:", currentSelectItem.value)
    //     setApplyButton();
    //     setRetrybtn();      
    // }


    // const setRetrybtn = ()=>{
    //     if( rSeletBox.value && rSeletBox.value.value)
    //     {
    //         if( rSeletBox.value.value.split('^')[3] != 'undefined'  && rSeletBox.value.value.split('^')[3] != undefined && rSeletBox.value.value.split('^')[3] != null && rSeletBox.value.value.split('^')[3] != '')
    //         {
    //             currentResetData.value[0] =  rSeletBox.value.value.split('^')[3];
    //         }

    //         if( rSeletBox.value.value.split('^')[4] != 'undefined'  && rSeletBox.value.value.split('^')[4] != undefined && rSeletBox.value.value.split('^')[4] != null && rSeletBox.value.value.split('^')[4] != '')
    //         {
    //             currentResetData.value[1] =  rSeletBox.value.value.split('^')[4];
    //         }
    //     }
    // }



    watch(isLogin, ()=>{
       // console.log("isLogin", isLogin.value )
        getVContestData('S');
        getVContestData('F');
        getVContestData('G');
        getVContestData('C');
    })


    const goLoginPage = ()=>{ 
        location.href = process.env.VUE_APP_flexTvUrl + `partner/money/signin?&callbackUrl=${process.env.VUE_APP_flexMoneyUrl}`;
    }



    const onRegisterTrade =  (item) =>{


        if(!isLogin.value)
        {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
            return;
        }
        // if(vContestData.value.length == 0)
        // {
        //     emitter.emit('EVENT_ALERT',{title:"알림", body:"개최중인 대회가 없습니다."});
        //     return;
        // }
        currentSelectItem.value = item;
        var str = item._isApply;
        if(str == 1  || str == 2){
            emitter.emit('EVENT_ALERT',{title:"알림", body:"이미 신청한 상태입니다."});
            return;
        }
        else
        {
            showModal.value = true;
        }
    }

    const onGotoTrade = (type) =>{
        // if(!isLogin.value)
        // {
        //   emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.",fn:goLoginPage});
        //   return;
        // }
        //var type = rSeletBox.value.value.split('^')[1]; 
        //trace("onGotoTrade", type, rSeletBox.value.value)
        var name = '';
        if(type == "S")
        {
            name = 'VtradeStock';
        }
        else if(type == "F")
        {
            name = 'VtradeFutures';
        }
        else if(type == "C")
        {
            name = 'VtradeCoin';
        }
        else if(type == "G")
        {
            name = 'VtradeCoinFutures';
        }       

        router.push({
            name: name,
            params: {
            //  id:rSeletBox.value.value.split('^')[0]
                id:'0'
            }
        }) 

    }


    const onDetailInfo = () =>{
         window.open( 'https://www.flexmoney.co.kr/notice/4329'); 
       // var currentSpaceId = rSeletBox.value.value.split('^')[0];
    //     vContestData.value.forEach(element => {
            
    //        // if(element.ID == currentSpaceId){
    //         // console.log("eeee", element.INFO_LINK_URL,  element.INFO_IMG_URL)
    //         if(element.INFO_LINK_URL == null)return;
    //             window.open( element.INFO_LINK_URL); 
    //             return
    //         }        
    //    // }
    //     );
    }
    
    const closeModal =()=>{
        showModal.value = false; 
    }

    const okModal = async() =>{
        showModal.value = false; 
        var id = currentSelectItem.value.ID;
        var params = { "spaceId": id}
        var res =  await apiCall_pt('vspace/apply', params, null, (message)=>{
        emitter.emit('EVENT_ALERT',{title:"알림", body:message});
        });
        if(res)
        {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"모의투자에 성공적으로 신청되었습니다."});
            store.dispatch('hts/setApplySpace'); 
            getVContestData('S');
            getVContestData('F');
            getVContestData('G');
            getVContestData('C');
            event('participate', { 'ID': memberData.value.MID, 'competitions_name': 'main_' + getSpaceTypeStr(res.spaceType), 'time': moment(new Date()).format('YYYYMMDD HH:mm:ss')});
            window.fbq('trackCustom', 'participate', {'ID': memberData.value.MID,  'competitions_name': 'main_' + getSpaceTypeStr(res.spaceType) , 'time': moment(new Date()).format('YYYYMMDD HH:mm:ss') });
            console.log("event~ :", memberData.value.MID, 'competitions_name', 'main_' + getSpaceTypeStr(res.spaceType),  moment(new Date()).format('YYYYMMDD HH:mm:ss'))
        }
    }

    const getSpaceTypeInfoStr = (_type) =>{
        var result = null;
        if(_type == 'S')
        {
            result = '국내주식 모의투자로 실전 감각을 차근차근 익혀보세요'
        }
        else if(_type == 'F')
        {
            result = '해외선물 모의투자로 글로벌 시장의 변동성을 경험해보세요'
        }
        else if(_type == 'C')
        {
            result = '코인현물 모의투자로 부담 없이 매매 타이밍을 익혀보세요'
        }
        else if(_type == 'G')
        {
            result = '코인선물 모의투자로 빠른 변동성 속에서 많은 연습해보세요'
        }
        return result;        
    }

    const getSpaceTypeName = (_type) =>{
        var result = null;
        if(_type == 'S')
        {
            result = '국내주식'
        }
        else if(_type == 'F')
        {
            result = '해외선물'
        }
        else if(_type == 'C')
        {
            result = '코인현물'
        }
        else if(_type == 'G')
        {
            result = '코인선물'
        }

        //console.log(_type)
        return result;        
    }

    const getSpaceTypeStr = (_type) =>{
        var result = null;
        if(_type == 'S')
        {
            result = 'Stock'
        }
        else if(_type == 'F')
        {
            result = 'Futures'
        }
        else if(_type == 'C')
        {
            result = 'Crypto'
        }
        else if(_type == 'G')
        {
            result = 'CoinFutures'
        }
        return result;        
    }


    const closeModal_retry =()=>{
        showModal_retry.value = false; 
    }

    const okModal_retry = async() =>{
        showModal_retry.value = false; 
        //var accountId = rSeletBox.value.value.split('^')[0]
        var res = await apiCall_pt(`vspace/retrySpace`, {"accountId": currentSelectItem.value._accountId },null,(_message)=>{
            emitter.emit('EVENT_ALERT',{title:"알림", body:_message});
        });
         //console.log("onRetryOk:", res)
        if(!res)return         
        emitter.emit('EVENT_ALERT',{title:"알림", body:"초기화 되었습니다. 새로고침 합니다.", fn:()=>{window.location.reload()}});
    }  

    const onClickRetry_retry =(item)=>{
        if(!isLogin.value)
        {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
            return
        }
        currentSelectItem.value = item;
        if(currentSelectItem.value._isApply != '2')
        {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"대회참가 후 사용가능합니다."});
            return
        }
        showModal_retry.value = true; 
    }

    const settings = {
        itemsToShow: 4,
        snapAlign: 'start',
        wrapAround: false,
        transition: 500,
        mouseDrag: false,
        touchDrag: false,
    };



    return{
       // vContestData,
       // onSeletChange,
        rSeletBox,
        onRegisterTrade,
        onGotoTrade,
        onDetailInfo,
        btn_apply_ok,
        currentResetData,
        showModal,
        closeModal,
        okModal,
        isChecked,
        currentSelectItem,
        showModal_retry,
        closeModal_retry,
        okModal_retry,
        onClickRetry_retry,
        mainVisualUrl,
        isOpenStock,
        isOpenFutures,
        isOpenCoin,
        isOpenCoinFutures,
        getSpaceTypeName,
        moment,
        getSpaceTypeInfoStr,
        settings,
        vContestData_S,
        vContestData_F,
        vContestData_C,
        vContestData_G,
        Constant,
        getProfitPreType,
        getProfitType,
        getMyRankType,
    }
   }
}
</script>

<style>

</style>